export default function Footer() {
  return (
    <footer id="footer" className="bg-primary-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg md:text-xl font-heading font-bold text-background-50 mb-3 block">
              五一吃瓜网
            </span>
            <p className="text-xs md:text-sm text-background-300 leading-relaxed">
              最新最全吃瓜资讯聚合平台，为广大瓜友提供官方入口与热门吃瓜事件主页，全网热点一站直达。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">首页</a>
              <a href="#updates" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">最新快讯</a>
              <a href="#carousel" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#ranking" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">吃瓜排行</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">热门专题</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">娱乐圈</a>
              <a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">网红八卦</a>
              <a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">综艺热点</a>
              <a href="#topics" className="text-xs md:text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap">影视爆料</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs md:text-sm text-background-400">
              合作伙伴信息持续更新中
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-primary-700/40 gap-4">
          <p className="text-xs text-background-400">
            &copy; 2026 五一吃瓜网 www.51chigua.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-background-400 hover:text-background-50 transition-colors whitespace-nowrap">常见问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}